"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.detectCreditCardType = detectCreditCardType;
const legacy_enums_1 = require("@daytrip/legacy-enums");
function detectCreditCardType(ccNumber) {
    let detectedCCType = { isValid: false };
    legacy_enums_1.CreditCardTypes.forEach((ccType) => {
        if (ccType.regexp && ccNumber.match(ccType.regexp) != null) {
            detectedCCType = ccType;
        }
    });
    return detectedCCType;
}
//# sourceMappingURL=detectCreditCardType.js.map